import React from "react";

export default function PrivacyDisclaimer() {
	return (
		<div id="legal-inner" className="light">
			<h2>AVISO DE PRIVACIDAD INTEGRAL DE CONTISHOP</h2>
			<p>
				<em>Fecha: 15/05/2025</em>
			</p>
			<p>
				Este Aviso de Privacidad Integral se aplica a Conti Shop a través de la
				plataforma (en adelante Plataforma) contratada para tal efecto y que se
				encuentra disponible en el siguiente link:{" "}
				<strong>www.contishop.com.mx</strong>.
			</p>
			<p>
				Este documento tiene como objetivo brindarle información sobre cómo
				Continental Tire de México S. de R.L. de C.V. y sus filiales, en
				adelante “CONTINENTAL TIRE” recopila y da tratamiento a sus datos
				personales a través de la Plataforma Conti Shop.
			</p>
			<p>
				Es importante que lea esta Aviso de Privacidad Integral junto con
				cualquier otra Política de privacidad general que podamos proporcionarle
				cuando recopilamos o tratamos datos personales sobre usted para que sea
				plenamente consciente de cómo y por qué estamos utilizando sus datos.
			</p>
			<p>
				Este Aviso de Privacidad Integral complementa el aviso de privacidad
				para empleados y la Política de privacidad de CONTINETAL TIRE y no
				pretende anularlos.
			</p>
			<p>
				Al ingresar, registrarse y utilizar la Plataforma, cuyo nombre de
				dominio es: <strong> www.contishop.com.mx</strong> propiedad de
				CONTINENTAL TIRE, usted (como usuario/a) está aceptando los términos y
				las condiciones contenidos en este Aviso de Privacidad Integral.
			</p>
			<p>
				Si usted no acepta en forma absoluta los términos y condiciones de este
				Aviso de Privacidad Integral deberá abstenerse de acceder a
				www.contishop.com.mx, en caso de que el usuario/a continúe con el uso de
				www.contishop.com.mx, dicha acción se considerará como su aceptación
				tácita a los términos y condiciones aquí establecidos. La sola
				utilización del sitio le otorga al público en general o a quien lo use,
				la condición de usuario (en adelante referido como el "usuario",
				“usuaria” o los "usuarios") e implica la aceptación, plena e
				incondicional, de todas y cada una de las condiciones generales y
				particulares incluidas en este Aviso de Privacidad Integral.
			</p>
			<h3>1. Normativa aplicable</h3>
			<p>
				<strong>"RGPD"</strong> significa el Reglamento General de Protección de
				Datos (Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de
				27 de abril de 2016, relativo a la protección de las personas físicas en
				lo que respecta al tratamiento de datos personales, a la libre
				circulación de estos datos y por el que se deroga la Directiva
				95/46/CE).
			</p>
			<p>
				<strong>"Legislación de Protección de Datos Aplicable"</strong>{" "}
				significa todas y cada una de las leyes, regulaciones o normas
				aplicables a la recopilación, tratamiento, intercambio o uso de datos
				personales o que puedan aplicarse en el contexto de una violación o
				divulgación no autorizada de datos personales, incluido el RGPD y las
				"Leyes Mexicanas de Protección de Datos".
			</p>
			<p>
				<strong>"Leyes Mexicanas de Protección de Datos"</strong> significa la
				Ley Federal de Protección de Datos Personales en Posesión de los
				Particulares (LFPDPPP), el Reglamento de la Ley Federal de Protección de
				Datos Personales (RLFPDPPP), así como cualquier ley o reglamento federal
				relacionado con la privacidad de datos y/o la protección de datos
				personales en México vigentes.
			</p>
			<h3>2. ¿Quién es el responsable del tratamiento de sus datos?</h3>
			<p>
				Continental Tire de México, S. de R.L. de C.V., con domicilio ubicado en
				Av. Santa Fe N°170, 7° piso, Lomas de Santa Fe, Ciudad de México, C.P.
				01210 México.
			</p>
			<p>
				Hemos designado a un Delegado de Protección de Datos (en adelante DPO)
				que es responsable de supervisar las preguntas relacionadas con este
				Aviso de Privacidad Integral. Si tiene alguna pregunta sobre esta Aviso
				de Privacidad Integral, por favor póngase en contacto con el DPO
				utilizando los datos que se indican a continuación. Los datos para
				contactarlo son:
			</p>
			<p>
				Domicilio: Av. Santa Fe N°170, piso 7, Lomas de Santa Fe, Ciudad de
				México, C.P. 01210, México.
				<br />
				Correo electrónico:{" "}
				<a href="mailto:arco@continental-corporation.com">
					arco@continental-corporation.com
				</a>
			</p>
			<h3>
				3. Cambios en el Aviso de Privacidad Integral y su deber de informarnos
				de los cambios
			</h3>
			<p>
				Mantenemos nuestra Aviso de Privacidad Integral bajo revisión regular.
				Esta versión se actualizó por última vez en mayo 15 de 2025.
			</p>
			<p>
				Es importante que los datos personales que tenemos sobre usted sean
				precisos y estén actualizados. Por favor, manténganos informados si sus
				datos personales cambian durante su relación con nosotros.
			</p>
			<h3>4. ¿Qué datos personales se tratan?</h3>
			<ul>
				<li>
					<strong>Datos de identificación:</strong> Nombre (nombre y apellidos),
					fecha de nacimiento, número de empleado (a), nombre de usuario.
				</li>
				<li>
					<strong>Datos de contacto:</strong> Correo electrónico y número de
					teléfono.
				</li>
				<li>
					<strong>Datos técnicos:</strong> Fecha y hora de uso de la Plataforma,
					así como la dirección de protocolo de Internet (IP), identificadores
					únicos, el tipo de navegador y su configuración, el tipo de
					dispositivo y su configuración, el sistema operativo, información
					sobre la red móvil (como el nombre del operador y el número de
					teléfono) y el número de versión de la aplicación, la interacción de
					tus aplicaciones, navegadores y dispositivos con nuestros servicios,
					como la dirección IP, informes sobre fallos, actividad del sistema,
					así como la fecha, la hora y la URL de referencia de tu petición.
				</li>
				<li>
					<strong>Datos de perfil:</strong> incluye su nombre de usuario y
					contraseña.
				</li>
			</ul>
			<p>
				No recopilamos ninguna{" "}
				<strong>categoría especial de datos personales</strong> sobre usted
				(esto incluye detalles sobre su raza o etnia, creencias religiosas o
				filosóficas, vida sexual, orientación sexual, información sobre su salud
				y datos genéticos, por citar algunos).
			</p>
			<h3>5. ¿Cómo se recopilan sus datos personales?</h3>
			<p>
				Sus datos personales se recopilan cuando interactúa directamente con
				nosotros, al crear una cuenta y contraseña de acceso para utilizar Conti
				Shop a través de la Plataforma que se encuentra disponible en el
				siguiente link:{" "}
				<a href="https://www.contishop.com.mx">www.contishop.com.mx</a>
			</p>
			<h3>
				6. ¿Con qué finalidades y sobre qué base jurídica se tratan sus datos?
			</h3>
			<p>
				A continuación, en formato de tabla, presentamos una descripción de
				todas las formas en que planeamos utilizar sus datos personales y cuáles
				de las bases legales en las que nos basamos para hacerlo. También hemos
				identificado cuáles son nuestros intereses legítimos.
			</p>
			<p>
				<strong>Finalidades:</strong>
			</p>
			<ul>
				<li>Permitirnos proporcionarle acceso a la Plataforma.</li>
				<li>Para mantener nuestros registros actualizados.</li>
				<li>
					Para registrarle como nuevo usuario de Conti Shop y permitirle acceder
					y utilizar la plataforma Conti Shop.
				</li>
				<li>
					Para gestionar nuestra relación con usted, que incluye: (a)
					Responderle (cualquier pregunta/consulta planteada, etc.); (b)
					Notificarle los cambios en la Plataforma; (c) Notificarle sobre
					cambios en nuestros Términos de uso o este aviso de privacidad.
				</li>
				<li>Procesar su solicitud de pedido y/o compra en Conti Shop.</li>
				<li>
					Procesar su pago por compra de productos de Conti Shop, vía un tercero
					que gestiona la pasarela de pagos. (Open Pay)
				</li>
				<li>
					Generar su comprobante de pago, de productos de Conti Shop, vía un
					tercero (Open Pay) que gestiona la pasarela de pagos. Cuya Política de
					Privacidad puede consultarla a través del siguiente link:
					<a
						href="https://www.openpay.mx/aviso-privacidad/"
						target="_blank"
						rel="noreferrer"
					>
						Openpay | Posibilidades Infinitas
					</a>
				</li>
				<li>
					Enviarle correos electrónicos relacionados con su pedido (s) y/o pago
					(s).
				</li>
				<li>
					Resolver sus dudas, consultas y dar seguimiento a su (s) pedido (s)
					realizado (s) en la plataforma.
				</li>
				<li>
					Gestión y evaluación del sistema de centro de soporte de Conti Shop
					para clientes.
				</li>
				<li>Revisar el estatus de su (s) pedido (s).</li>
				<li>
					Enviarle correos electrónicos para la entrega y gestión de sus
					compras, a través de la red de distribuidores CONTINENTAL TIRE.
				</li>
				<li>
					Para administrar y proteger nuestro negocio y la Plataforma, incluida
					la resolución de problemas, el análisis de datos y las pruebas del
					sistema.
				</li>
				<li>
					Utilizar el análisis de datos para mejorar el servicio y la
					Plataforma.
				</li>
				<li>
					Para el funcionamiento de nuestro negocio, la prestación de servicios
					administrativos y de TI, para la seguridad de la red, para desarrollar
					los productos/servicios y hacer crecer nuestro negocio.
				</li>
			</ul>
			<p>
				<strong>Base jurídica</strong>
			</p>
			<ul>
				<li>
					Su consentimiento expreso y/o tácito (Al ingresar, registrarse y
					utilizar la Plataforma, propiedad de CONTINENTAL TIRE, usted (como
					usuario/a) está aceptando los términos y las condiciones contenidos en
					este Aviso de Privacidad Integral.{" "}
				</li>
				<li>
					Para la ejecución de un contrato de compraventa de llantas, a través
					de la Plataforma.
				</li>
			</ul>
			<h3>7. Cambio de propósito</h3>
			<p>
				Solo utilizaremos sus datos personales para los fines para los que los
				recopilamos, a menos que consideremos razonablemente que necesitamos
				utilizarlos por otro motivo y que ese motivo sea compatible con el
				propósito original. Si deseara obtener una explicación sobre cómo el
				tratamiento para el nuevo propósito es compatible con el propósito
				original, póngase en contacto con nosotros a través del siguiente correo
				electrónico:{" "}
				<a href="mailto:arco@continental-corporation.com">
					arco@continental-corporation.com
				</a>
			</p>
			<p>
				Si necesitamos utilizar sus datos personales para un propósito no
				relacionado, se lo notificaremos y le explicaremos la base legal que nos
				permite hacerlo.
			</p>
			<p>
				Tenga en cuenta que podemos dar tratamiento a sus datos personales sin
				su conocimiento o consentimiento, de conformidad con las reglas
				siguientes (art. 9 de la Ley Federal de Protección de Datos Personales
				en Posesión de Particulares vigente:
			</p>
			<ol type="I">
				<li>Una disposición jurídica así lo disponga;</li>
				<li>Los datos personales figuren en fuentes de acceso público;</li>
				<li>
					Los datos personales se sometan a un procedimiento previo de
					disociación;
				</li>
				<li>
					Los datos personales se requieran para ejercer un derecho o cumplir
					obligaciones derivadas de una relación jurídica entre la persona
					titular y el responsable;
				</li>
				<li>
					Exista una situación de emergencia que potencialmente pueda dañar a un
					individuo en su persona o en sus bienes;
				</li>
				<li>
					Los datos personales sean indispensables para efectuar un tratamiento
					para atención médica, la prevención, diagnóstico, la prestación de
					asistencia sanitaria, o la gestión de servicios sanitarios, mientras
					la persona titular no esté en condiciones de otorgar el
					consentimiento, en los términos que establece la Ley General de Salud
					y demás disposiciones jurídicas aplicables y que dicho tratamiento de
					datos se realice por una persona sujeta al secreto profesional u
					obligación equivalente, o
				</li>
				<li>
					Exista una orden judicial, resolución o mandato fundado y motivado de
					autoridad competente.
				</li>
			</ol>
			<h3>
				8. ¿A qué categorías de destinatarios se transfieren sus datos
				personales?
			</h3>
			<p>
				Podemos compartir sus datos personales con las partes que se indican a
				continuación, para los fines establecidos a continuación:
			</p>
			<p>
				<strong>Terceros internos</strong>
			</p>
			<p>
				Es posible que compartamos sus datos personales con otras entidades del
				grupo mundial de empresas del que forma parte CONTINENTAL TIRE.
			</p>
			<p>
				<strong>Terceros externos</strong>
			</p>
			<p>
				Compartimos sus datos personales con los siguientes terceros externos.
			</p>
			<table>
				<thead>
					<th>Empresa</th>
					<th>Tema</th>
					<th>Ubicación del centro de datos / tratamiento</th>
				</thead>
				<tbody>
					<tr>
						<td>
							<strong>Ramva Net S.A. de C.V.</strong>
							<br />
							Av. De los Pinos #18
							<br />
							Col. San Clemente Las Águilas
							<br />
							Álvaro Obregón, C. P. 01740
						</td>
						<td>
							Hospedaje web y mantenimiento de la Plataforma, herramienta de
							administración y su respectiva API.
						</td>
						<td>Estados Unidos de América / Ciudad de México, México.</td>
					</tr>
					<tr>
						<td>
							<strong>Google Analytics</strong>
							<br />
							1600 Amphitheatre Parkway
							<br />
							Mountain View, California 94043, EUA
						</td>
						<td>Para fines estadísticos relacionados con la Plataforma.</td>
						<td>California, Estados Unidos de América</td>
					</tr>
					<tr>
						<td>
							<strong>Open Pay, S.A.P.I. de C.V.</strong> <br />
							Av. 5 de Febrero No. 1351, interior Sequoia 102
							<br /> Col. Felipe Carrillo Puerto. Querétaro, Querétaro.
						</td>
						<td>Gestión de pasarela de pagos</td>
						<td>Querétaro, Querétaro, México </td>
					</tr>
					<tr>
						<td>
							<strong>Vangtel México, S.A. de C.V. (Intugo)</strong> <br />
							Blvd. Río Sonora No. 110 Int.13
							<br />
							Hacienda de la Flor Hermosillo
							<br /> SONORA, 83178 Mexico
						</td>
						<td>
							Gestión de servicio de servicio remoto del Centro de Contacto
							Telefónico (call center) de Conti Shop.
						</td>
						<td>Ciudad de México, México.</td>
					</tr>
				</tbody>
			</table>
			<p>
				Exigimos a todos los terceros que respeten la seguridad de sus datos
				personales y que los traten de acuerdo con la Legislación de Protección
				de Datos Aplicable. No permitimos que nuestros proveedores de servicios
				externos utilicen sus datos personales para sus propios fines y solo les
				permitimos dar tratamiento a sus datos personales para fines específicos
				y de acuerdo con nuestras instrucciones.
			</p>
			<p>
				También podemos compartir sus datos personales si creemos que tenemos
				que hacerlo para cumplir con la ley o para protegernos. Si es necesario,
				compartimos los datos para responder a una orden judicial o
				requerimiento, o en respuesta a una solicitud de una dependencia
				gubernamental o un organismo de investigación.
			</p>
			<p>
				Compartimos con cualquier sucesor de todo o parte de nuestro negocio. Si
				se vende la totalidad o parte de nuestro negocio, podemos compartir los
				datos personales como parte de esa transacción. Si hay una fusión o
				adquisición, también podemos compartir sus datos personales. En caso de
				financiación o quiebra, es posible que compartamos sus datos personales.
			</p>
			<h3>9. ¿Durante cuánto tiempo se almacenarán los datos?</h3>
			<p>
				Solo conservaremos sus datos personales durante el tiempo que sea
				razonablemente necesario para cumplir con los fines para los que los
				recopilamos, incluidos los fines de satisfacer cualquier requisito
				legal, reglamentario, fiscal, contable o de presentación de informes.
			</p>
			<p>
				Podemos conservar sus datos personales durante un período más largo en
				caso de una queja o si creemos razonablemente que existe la posibilidad
				de un litigio con respecto a nuestra relación con usted.
			</p>
			<p>
				Para determinar el período de retención adecuado para los datos
				personales, consideramos la cantidad, la naturaleza y la sensibilidad de
				los datos personales, el riesgo potencial de daño por el uso o la
				divulgación no autorizados de sus datos personales, los fines para los
				que tratamos sus datos personales y si podemos lograr esos fines a
				través de otros medios, y las disposiciones legales aplicables.
				requisitos reglamentarios, fiscales, contables o de otro tipo.
			</p>
			<h3>10. ¿Se transfieren datos a países de la UE/EEE?</h3>
			<p>
				Continental tiene su sede en Alemania, por lo que sus datos pueden
				compartirse con el Reino Unido y el Espacio Económico Europeo (EEE).
			</p>
			<p>
				También podemos compartir sus datos personales dentro del Grupo
				Continental. Esto también implicará transferir sus datos al Reino
				Unido/EEE o fuera de estos. Nos aseguramos de que sus datos personales
				estén protegidos exigiendo a todas las empresas de nuestro grupo que
				sigan las mismas normas al dar tratamiento a sus datos personales. Estas
				normas se denominan "normas corporativas vinculantes". Para obtener más
				información, consulte{" "}
				<a href="https://www.continental-corporation.com/resource/blob/62352/cd182443aa962ea40a44b5d017453e98/binding-corporate-rules-de-data.pdf">
					Binding Corporate Rules
				</a>
				.
			</p>
			<h3>
				11. ¿Qué derechos tiene usted como titular de los datos o interesado?
			</h3>
			<p>
				Una vez que haya proporcionado sus datos personales, tiene varios
				derechos, que puede ejercer de forma gratuita, sujeto a excepciones
				legales. Estos derechos pueden estar limitados, por ejemplo, si el
				cumplimiento de su solicitud revelara datos personales sobre otra
				persona, o si nos pide que eliminemos información que estamos obligados
				por ley a conservar.
			</p>
			<p>
				Es posible que necesitemos solicitarle información específica para
				ayudarnos a confirmar su identidad y garantizar su derecho a acceder a
				sus datos personales (o a ejercer cualquiera de sus otros derechos). Se
				trata de una medida de seguridad para garantizar que los datos
				personales no se divulguen a ninguna persona que no tenga derecho a
				recibirlos. También podemos ponernos en contacto con usted para
				solicitarle más información en relación con su solicitud para acelerar
				nuestra respuesta.
			</p>
			<p>
				Usted o su representante legal podrá ejercer cualquiera de los derechos
				de acceso, rectificación, cancelación u oposición (en lo sucesivo
				“Derechos ARCO”), así como revocar su consentimiento para el tratamiento
				de sus datos personales enviando un correo electrónico al Oficial de
				Privacidad de Datos Personales designado por Continental a la dirección{" "}
				<a href="mailto:arco@continental-corporation.com">
					arco@continental-corporation.com
				</a>{" "}
				donde se le atenderá en tiempo y forma.
			</p>
			<p>Su solicitud deberá contener como mínimo:</p>
			<ol type="I">
				<li>
					El nombre de la persona titular y su domicilio o cualquier otro medio
					para recibir notificaciones;
				</li>
				<li>
					Los documentos que acrediten la identidad de la persona titular o, en
					su caso, la personalidad e identidad de su representante;
				</li>
				<li>
					La descripción clara y precisa de los datos personales respecto de los
					que se busca ejercer alguno de los derechos ARCO, salvo que se trate
					del derecho de acceso;
				</li>
				<li>
					La descripción del derecho ARCO que se pretende ejercer, o bien, lo
					que solicita la persona titular, y
				</li>
				<li>
					Cualquier otro elemento o documento que facilite la localización de
					los datos personales.
				</li>
			</ol>
			<p>
				En caso de que su petición no sea clara o esté completa se le requerirá
				el llenado de una Solicitud de Derechos ARCO y Revocación del
				Consentimiento (en lo sucesivo “Solicitud”), la cual debe ser enviada a
				la dirección de correo electrónico arriba señalada. Dicha Solicitud se
				le hará llegar por correo electrónico al mail que haya utilizado para
				mandarnos su petición.
			</p>
			<p>
				La Solicitud que le haremos llegar contiene todos los elementos y
				requisitos para poder atender su ejercicio de derechos ARCO, conforme a
				la normatividad vigente, con el objeto de que el Oficial de Privacidad
				de Datos Personales pueda darle atención y seguimiento a su solicitud.
			</p>
			<p>
				Usted o su representante legal, en su caso, deberá acreditar
				correctamente su identidad por lo que es necesario que complete todos
				los campos indicados en la Solicitud y lo acompañe con copia de alguna
				de las identificaciones oficiales vigentes que se señalan en el mismo.
				En caso de que la información proporcionada en la Solicitud sea errónea
				o insuficiente, o bien, no se acompañen los documentos de acreditación
				correspondientes, el Oficial, dentro de los cinco (5) días hábiles
				siguientes a la recepción de la solicitud, podrá requerir al titular que
				aporte los elementos o documentos necesarios para dar trámite a la
				misma. Usted contará con diez (10) días hábiles para atender el
				requerimiento, contados a partir del día siguiente en que lo haya
				recibido. De no dar respuesta en dicho plazo, se tendrá por no
				presentada la solicitud correspondiente.
			</p>
			<p>
				El Oficial de Privacidad de Datos Personales designado por Continental
				le comunicará la determinación adoptada, en un plazo máximo de veinte
				(20) días hábiles contados desde la fecha en que se recibió la
				solicitud, a efecto de que, si resulta procedente, haga efectiva la
				misma dentro de los quince (15) días hábiles siguientes a que se
				comunique la respuesta. La respuesta se dará vía electrónica a la
				dirección de correo que se especifique en el Formulario
			</p>
			<p>
				Si tiene alguna pregunta sobre el aviso de privacidad o desea ejercer
				alguno de sus derechos, no dude en ponerse en contacto con nuestro
				responsable de protección de datos:
			</p>
			<ul>
				<li>
					<strong>Correo electrónico:</strong>{" "}
					<a href="mailto:arco@continental-corporation.com">
						arco@continental-corporation.com
					</a>
				</li>
				<li>
					<strong>Domicilio:</strong> Av. Santa Fe N°170, piso 7°, Lomas de
					Santa Fe, Ciudad de México, C.P. 01210, México.
				</li>
			</ul>
			<h3>12. Autoridad de Protección de Datos</h3>
			<p>
				En caso de considerarlo necesario, le informamos que tiene el derecho de
				acudir ante la <strong>Unidad de Protección de Datos Personales</strong>{" "}
				adscrita a la
				<strong>Secretaría Anticorrupción y Buen Gobierno</strong> para hacer
				valer cualquier inconformidad relacionada con su derecho a la protección
				de datos personales.
			</p>
			<h3>13. Disposiciones de cierre</h3>
			<p>
				CONTINENTAL TIRE puede realizar cambios o modificar en cualquier momento
				este aviso de privacidad.
			</p>
			<p>
				En cada caso de cambio previsto en este aviso de privacidad, CONTINENTAL
				TIRE le notificará con una antelación razonable antes de que cualquier
				cambio entre en vigor. Dicha notificación se realizará mediante una
				ventana emergente en caso de que no se requiera un registro.
			</p>
			<p>
				Si cambiamos o modificamos este aviso de privacidad, es posible que deba
				dar su consentimiento para continuar usando la Plataforma marcando la
				casilla de suscripción respectiva de la ventana emergente.
			</p>
			<p>
				<em>Esta versión entra en vigor a partir del 15 de mayo de 2025.</em>
			</p>
		</div>
	);
}
